export class ShareUrlModel {
    urlString: string;
    key: string;

    constructor(args: {urlString: string}) {
        this.urlString = args.urlString;
        this.key = Date().toLocaleString();
    }
}